import * as React from 'react';
import { useDispatch } from 'react-redux';

import { INewbuildingBuilder, ISeller } from '../../types/newbuilding/builder';

import { trackShowPhone } from '../../actions/analytics';

import { CallBuilder } from '../../components/MobileCall/CallBuilder';
import { TThunkDispatch } from '../../types/redux';
import { phoneToString } from '../../utils/phone/phoneToString';

interface ICallBuilderContainerProps {
  placeType?: string;
  target: INewbuildingBuilder | ISeller;
}
export const CallBuilderContainer: React.VFC<ICallBuilderContainerProps> = ({ placeType, target }) => {
  const dispatch = useDispatch<TThunkDispatch>();

  const trackActionOpenContactsCall = React.useCallback(() => {
    dispatch(trackShowPhone('Open_jk_card'));
  }, [dispatch, target]);

  const phone = phoneToString(target.phone);

  /* istanbul ignore next */
  if (!phone) {
    return null;
  }

  return (
    <CallBuilder
      siteBlockId={target.dynamicCalltracking?.siteBlockId}
      phone={phone}
      trackAction={trackActionOpenContactsCall}
      placeType={placeType}
    />
  );
};
